.list {
  list-style: none;
  margin: 0;
  padding: 8px 0;
}

.dense {
  padding: 4px 0;
}

.item {
  display: flex;
  align-items: center;
  position: relative;
  padding: 8px 16px;
  text-decoration: none;
  width: 100%;
  box-sizing: border-box;
  border-radius: 8px;
  margin-top: 4px;
  margin-bottom: 4px;
}

.itemDense {
  padding: 4px 16px;
}

.itemButton {
  cursor: pointer;
  background: none;
  border: none;
  font: inherit;
  color: inherit;
  text-align: start;
  -webkit-tap-highlight-color: transparent;
}

.itemButton:hover,
.itemButton[aria-selected='true'],
.item[tabindex]:hover {
  background-color: var(--tuna-palette-action-hover);
}

.itemSelected {
  background-color: var(--tuna-palette-action-selected);
}

.itemIcon {
  display: inline-flex;
  flex-shrink: 0;
  color: var(--tuna-palette-action-active);
  padding-right: 8px;
}

.itemAvatar {
  display: inline-flex;
  min-width: 56px;
  flex-shrink: 0;
}

.itemText {
  flex: 1 1 auto;
  min-width: 0;
}

.itemTextPrimary {
  display: block;
  font-size: var(--tuna-typography-body1-fontSize);
  line-height: var(--tuna-typography-body1-lineHeight);
  color: var(--tuna-palette-text-primary);
}

.itemTextSecondary {
  display: block;
  font-size: var(--tuna-typography-body2-fontSize);
  line-height: var(--tuna-typography-body2-lineHeight);
  color: var(--tuna-palette-text-secondary);
}

.itemSecondaryAction {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
}

.menuItem {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-body2-fontSize);
  line-height: var(--tuna-typography-body2-lineHeight);
  cursor: pointer;
  white-space: nowrap;
  background: none;
  border: none;
  width: 100%;
  text-align: start;
  color: inherit;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}

.menuItem svg {
  width: 20px;
  height: 20px;
}

.menuItem .itemTextPrimary {
  font-size: inherit;
  line-height: inherit;
}

.menuItem[data-highlighted],
.menuItem:hover,
.menuItem:focus-visible {
  background-color: var(--tuna-palette-action-hover);
  outline: none;
}

.menuItemSelected {
  background-color: var(--tuna-palette-action-selected);
}

.menuItem[data-disabled],
.menuItem:disabled,
.menuItem[aria-disabled='true'] {
  color: var(--tuna-palette-action-disabled);
  pointer-events: none;
}
